import { Controller } from 'stimulus';

// The version rail on the Release Notes list (release_notes/index): as the
// list scrolls, the entry for the release under the title bar is marked
// current and kept in view inside the rail. The scroll container is <main>,
// not the window, so positions come from getBoundingClientRect.
export default class extends Controller {
  static targets = ['item', 'rail'];

  connect() {
    this.scroller = this.element.closest('main') || window;
    this.onScroll = () => {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => { this.update(); this.ticking = false; });
    };
    this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    this.update();
  }

  disconnect() {
    this.scroller.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  update() {
    const releases = Array.from(this.element.querySelectorAll('article.rn-release'));
    if (releases.length === 0) return;
    const line = 140; // px from the top of the viewport; the release whose top is last above it is current
    let current = null;
    for (const release of releases) {
      if (release.getBoundingClientRect().top <= line) current = release; else break;
    }
    if (!current) current = releases[0];
    if (this.scrolledToBottom()) current = releases[releases.length - 1];

    this.itemTargets.forEach((item) => {
      const on = item.dataset.release === current.id;
      item.classList.toggle('is-current', on);
      if (on && this.hasRailTarget) this.keepVisible(item);
    });
  }

  scrolledToBottom() {
    const el = this.scroller === window ? document.documentElement : this.scroller;
    return el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
  }

  keepVisible(item) {
    const rail = this.railTarget;
    const top = item.offsetTop - rail.offsetTop;
    if (top < rail.scrollTop) rail.scrollTop = top;
    else if (top + item.offsetHeight > rail.scrollTop + rail.clientHeight) rail.scrollTop = top + item.offsetHeight - rail.clientHeight;
  }
}
